import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT, WHATSAPP_MSG } from "../../data/site";

export default function WhatsappFloat() {
  return (
    <motion.a
      href={`https://wa.me/${CONTACT.phoneRaw}?text=${WHATSAPP_MSG}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 grid place-items-center w-14 h-14 bg-[#25D366] text-white shadow-lg glow-coral"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={26} fill="white" />
      <span className="absolute inset-0 rounded-none bg-[#25D366] animate-ping opacity-20" />
    </motion.a>
  );
}
